import CommonService from './commonService'

class appService {

  //OSS存储服务器
  getOssParams() {
    return CommonService.getjsonp({
      body: {
        domain: 'open-rest.finger.inner',
        uri: '/api/oss/token'
      }
    })
  }

  getMobileCode({
    iid,
    mobile,
    userId
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'api.finger.inner',
        uri: '/v1/users/bindmobile/send/h5',
        iid,
        mobile,
        userId
      }
    });
  }

  login({
    iid,
    loginName,
    password
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/login',
        iid,
        loginName,
        password
      }
    });
  }

  sendCode({
    iid,
    loginName
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/sendCode',
        iid,
        loginName
      }
    });
  }

  changePassWord({
    iid,
    loginName,
    verifyCode,
    newPassword
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/changePassword',
        iid,
        loginName,
        verifyCode,
        newPassword
      }
    });
  }

  getStat({
    iid,
    fromIid,
    activity_id,
    groupClubId,
    queryKey,
    startTime,
    endTime,
    status
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/statistic',
        iid,
        fromIid,
        activity_id,
        groupClubId,
        queryKey,
        startTime,
        endTime,
        status
      }
    });
  }

  getMineData({
    iid,
    startTime,
    endTime,
    rid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/clubInfo',
        iid,
        startTime,
        endTime,
        rid
      }
    });
  }

  sendCopyText({
    content
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'yun.finger.inner',
        uri: '/parsePasteInfo',
        content,
        language:'CN'
      }
    })
  }

  bindMobile({
    iid,
    loginName,
    userId,
    verifyCode
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'api.finger.inner',
        uri: '/v1/users/mobile/bind/h5',
        iid,
        loginName,
        userId,
        verifyCode,
        language: 'CN'
      }
    })
  }

  getDownloadInfo({
    iid,
    userId,
    ridSecret
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'account.finger.inner',
        uri: '/api/account.interest.get.downInfo',
        iid,
        userId,
        ridSecret
      }
    });
  }

  createShortUrl({
    url
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'api.finger.inner',
        uri: '/v1/shorturl/create',
        url
      }
    })
  }

  parseShortUrl({
    url
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'api.finger.inner',
        uri: '/v1/shorturl/parse',
        url
      }
    })
  }

  //通过域名获取iid
  getiidByDomain({
    domainName
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'component2.finger.inner',
        uri: '/api/domain/byName',
        domainName
      }
    })
  }

  //获取验证码用于绑定手机号
  getCodeForBind({
    userId,
    mobile,
    iid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'api.finger.inner',
        uri: '/v1/users/bindmobile/send/h5',
        userId,
        mobile,
        iid,
        language: 'CN'
      }
    })
  }

  //绑定手机号
  bindMobile({
    loginName,
    userId,
    verifyCode,
    iid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'api.finger.inner',
        uri: '/v1/users/mobile/bind/h5',
        loginName,
        userId,
        verifyCode,
        iid,
        language: 'CN'
      }
    })
  }

  //查询用户权限
  getUserIdentity({
    iid,
    rid,
    unionId,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/permissions',
        iid,
        rid,
        unionId,
        saleIid
      }
    })
  }

  //获取线路目的地
  getActivityDestinations({
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/provinces',
        iid,
        saleIid
      }
    })
  }

  //获取线路列表
  getActivityList({
    iid,
    pageNo,
    queryKey,
    priceRange,
    place,
    dayRange,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/list',
        iid,
        pageNo,
        queryKey,
        priceRange,
        place,
        dayRange,
        language: 'CN',
        saleIid
      }
    })
  }

  //获取线路详情
  getActivityDetail({
    id,
    u,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/get',
        id,
        u,
        saleIid
      }
    })
  }

  //获取组团列表
  getGroupList({
    iid,
    activityId,
    startTime,
    queryKey,
    pageNumber,
    pageSize,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/group/list',
        iid,
        activityId,
        startTime,
        queryKey,
        pageNumber,
        pageSize,
        language: 'CN',
        saleIid
      }
    })
  }

  //新增报销
  addMaterial({
    id,
    rid,
    unionId,
    title,
    imagePath,
    price,
    remark,
    nickName,
    phone,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/group/addVoucher',
        id,
        rid,
        unionId,
        title,
        imagePath,
        price,
        remark,
        nickName,
        phone,
        iid,
        language: 'CN',
        saleIid
      }
    })
  }

  //更新报销 vouchers:Voucher数组转json串
  updateMaterial({
    id,
    vouchers,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/group/updateVoucher',
        id,
        vouchers,
        iid,
        language: 'CN',
        saleIid
      }
    })
  }

  //获取组团方列表
  getMyGroupTourList({
    iid,
    unionId,
    queryKey,
    pageNumber,
    pageSize,
    rank,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/groupClub/list',
        iid,
        unionId,
        queryKey,
        pageNumber,
        pageSize,
        rank,
        language: 'CN',
        saleIid
      }
    })
  }

  //查询某个线路的所有订单
  getOrderList({
    iid,
    unionId,
    activity_id,
    groupClubId,
    queryKey,
    startTime,
    pageNumber,
    pageSize,
    saleIid,
    status
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/list',
        iid,
        unionId,
        activity_id,
        groupClubId,
        queryKey,
        startTime,
        pageNumber,
        pageSize,
        language: 'CN',
        saleIid,
        status
      }
    })
  }

  //获取用户列表
  getUserList({
    iid,
    unionId,
    queryKey,
    pageNumber,
    pageSize,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/appUser/list',
        iid,
        unionId,
        queryKey,
        pageNumber,
        pageSize,
        language: 'CN',
        saleIid
      }
    })
  }

  //获取系统通知
  getMessageList({
    iid,
    pageNo,
    pageSize,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'open-rest.finger.inner',
        uri: '/api/report/msg/list',
        iid,
        pageNo,
        pageSize,
        language: 'CN',
        saleIid
      }
    })
  }

  //地接方添加组团社
  addGroupClub({
    iid,
    unionId,
    groupName,
    groupPhone,
    groupImage,
    users,
    ratio,
    ext,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/groupClub/add',
        iid,
        unionId,
        groupName,
        groupPhone,
        groupImage,
        users,
        ratio,
        ext,
        language: 'CN',
        saleIid
      }
    })
  }

  //获取组团方新建组团社的校验码
  getNewGroupClubCode({
    iid,
    unionId,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/genCode',
        iid,
        unionId,
        saleIid
      }
    })
  }

  //组团方添加组团社
  newGroupClub({
    iid,
    unionId,
    groupName,
    groupPhone,
    wechatNo,
    email,
    groupImage,
    users,
    code,
    saleIid,
    saleUserId
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/useCode',
        iid,
        unionId,
        groupName,
        groupPhone,
        wechatNo,
        email,
        groupImage,
        users,
        code,
        language: 'CN',
        saleIid,
        saleUserId
      }
    })
  }

  //获取地接方
  getInterests({
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/interests',
        iid,
        language: 'CN',
        saleIid
      }
    })
  }

  //修改组团社
  updateGroupClub({
    id,
    iid,
    unionId,
    groupName,
    groupPhone,
    wechatNo,
    email,
    groupImage,
    users,
    ratio,
    ext,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/groupClub/update',
        id,
        iid,
        unionId,
        groupName,
        groupPhone,
        wechatNo,
        email,
        groupImage,
        users,
        ratio,
        ext,
        language: 'CN',
        saleIid
      }
    })
  }

  //删除组团社
  deleteGroupClub({
    id,
    iid,
    unionId,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/groupClub/delete',
        id,
        iid,
        unionId,
        language: 'CN',
        saleIid
      }
    })
  }

  //获取报名需填字段
  getEnrollNeedInfos({
    detailId,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/fields',
        detailId,
        saleIid
      }
    })
  }

  //计算订单
  calculateOrder({
    unionId,
    detailId,
    joinDate,
    userInfos,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/calculate',
        unionId,
        detailId,
        joinDate,
        userInfos,
        iid,
        saleIid,
        language: 'CN'
      }
    })
  }

  //提交订单
  submitOrder({
    iid,
    unionId,
    detailId,
    joinDate,
    userInfos,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/join',
        iid,
        unionId,
        detailId,
        joinDate,
        userInfos,
        saleIid,
        language: 'CN'
      }
    })
  }

  //创建订单
  createOrder({
    iid,
    num,
    orderType,
    userId,
    keys,
    property,
    property2,
    name,
    phone,
    isNeedInsur,
    remark,
    ridSecret,
    queryUserId,
    useCoin,
    couponId,
    code,
    info,
    groupId,
    saleIid
  } = {}) {
    //name可能是用户输入的中文汉字，所以要node端处理
    return CommonService.getjsonp({
      body: {
        domain: 'order.finger.inner',
        uri: '/h5/order/create',
        iid,
        num,
        orderType,
        userId,
        keys,
        property,
        property2,
        name,
        phone,
        isNeedInsur,
        remark,
        ridSecret,
        queryUserId,
        useCoin,
        couponId,
        code,
        info,
        groupId,
        saleIid,
        language: 'CN'
      }
    })
  }

  //创建微信订单
  createWechatOrder({
    iid,
    rid,
    session,
    gid,
    channel,
    tradeType,
    openid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'mall.finger.inner',
        uri: '/api/order.wechat.create',
        iid,
        rid,
        session,
        gid,
        channel,
        tradeType,
        openid,
        language: 'CN',
        saleIid
      }
    })
  }

  //获取用户信息
  getUserInfo({
    userid,
    openid,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'account.finger.inner',
        uri: '/api/userV2.profile',
        userid,
        openid,
        iid,
        saleIid
      }
    })
  }

  //获取线路分享素材
  getFodderResource({
    iid,
    activityId,
    pageNumber,
    pageSize,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/source/list',
        iid,
        activityId,
        pageNumber,
        pageSize,
        saleIid
      }
    })
  }

  //获取运营中心线路列表数据
  getOperationActivityListData({
    unionId,
    startTime,
    endTime,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/liststat',
        unionId,
        startTime,
        endTime,
        iid,
        saleIid
      }
    })
  }

  //获取运营中心线路详情数据
  getOperationActivityAnalysisData({
    unionId,
    activityId,
    startTime,
    endTime,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/sumstat',
        unionId,
        activityId,
        startTime,
        endTime,
        iid,
        saleIid
      }
    })
  }

  //获取运营中心线路补充数据
  getOperationActivityAnotherAnalysisData({
    unionId,
    activityId,
    startTime,
    endTime,
    iid,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/groupstat',
        unionId,
        activityId,
        startTime,
        endTime,
        iid,
        saleIid
      }
    })
  }

  //获取运营中心最新订单数据
  getOperationOrderListData({
    iid,
    unionId,
    fromIid,
    activity_id,
    groupClubId,
    queryKey,
    startTime,
    endTime,
    pageNumber,
    pageSize,
    saleIid,
    status
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/list',
        iid,
        unionId,
        fromIid,
        activity_id,
        groupClubId,
        queryKey,
        startTime,
        endTime,
        pageNumber,
        pageSize,
        saleIid,
        status
      }
    })
  }

  getOperationOrderCountData({
    iid,
    unionId,
    fromIid,
    activity_id,
    groupClubId,
    queryKey,
    startTime,
    endTime,
    pageNumber,
    pageSize,
    saleIid,
    status
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/count',
        iid,
        unionId,
        fromIid,
        activity_id,
        groupClubId,
        queryKey,
        startTime,
        endTime,
        pageNumber,
        pageSize,
        saleIid,
        status
      }
    })
  }

  //订单申请退款
  refundOrder({
    id,
    userId,
    status
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/update',
        id,
        userId,
        status
      }
    })
  }

  //获取运营中心线路订单
  getOperationActOrderListData({
    iid,
    unionId,
    startTime,
    endTime,
    pageNumber,
    pageSize,
    saleIid,
    rid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/actInfoByClub1',
        iid,
        unionId,
        startTime,
        endTime,
        pageNumber,
        pageSize,
        saleIid,
        rid
      }
    })
  }

  //获取运营中心组团方订单
  getOperationClubOrderListData({
    iid,
    unionId,
    startTime,
    endTime,
    pageNumber,
    pageSize,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/stat/groupByClub',
        iid,
        unionId,
        startTime,
        endTime,
        pageNumber,
        pageSize,
        saleIid
      }
    })
  }

  //获取组团方线路分享明细
  getOperationShareOrderListData({
    iid,
    unionId,
    startTime,
    endTime,
    pageNumber,
    pageSize,
    shareId,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/shareInfo/groupByShareId',
        iid,
        unionId,
        startTime,
        endTime,
        pageNumber,
        pageSize,
        shareId,
        saleIid
      }
    })
  }

  //获取组团方线路分享明细
  getOperationShareOrdeDetailData({
    iid,
    unionId,
    startTime,
    endTime,
    pageNumber,
    pageSize,
    shareId,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/shareInfo/groupByUserId',
        iid,
        unionId,
        startTime,
        endTime,
        pageNumber,
        pageSize,
        shareId,
        saleIid
      }
    })
  }

  //获取活动出行日历
  getActivityCalendar({
    detailId,
    time,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/calendar',
        detailId,
        time,
        saleIid
      }
    })
  }

  //获取出团详情
  getGroupDetail({
    id,
    saleIid
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/group/get',
        id,
        saleIid
      }
    })
  }

  // 销售的接口
  getBills({
    iid,
    userId,
    personId,
    groupNo,
    status,
    adjuestStatus,
    queryKey,
    startTime,
    endTime,
    pageSize,
    pageNumber
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashBill/getList',
        iid,
        userId,
        personId,
        groupNo,
        status,
        adjuestStatus,
        queryKey,
        startTime,
        endTime,
        pageSize,
        pageNumber
      }
    })
  }
  delBills({
    iid,
    userId,
    id
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashBill/delete',
        iid,
        userId,
        id
      }
    })
  }

  saveBills({
    iid,
    userId,
    id,
    name,
    groupNo,
    billContent,
    billImages,
    billType,
    happenDate,
    price
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashBill/add',
        iid,
        userId,
        id,
        name,
        groupNo,
        billContent,
        billImages,
        billType,
        happenDate,
        price,
        language:'CN'
      }
    })
  }

  getBillsDetail({
    iid,
    userId,
    id,
    name,
    groupNo,
    billContent,
    billImages,
    billType,
    happenDate,
    price
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashBill/get',
        iid,
        userId,
        id,
        name,
        groupNo,
        billContent,
        billImages,
        billType,
        happenDate,
        price,
        language:'CN'
      }
    })
  }
  getCashInInstead({
    iid,
    userId,
    personId,
    groupNo,
    status,
    adjuestStatus,
    queryKey,
    pageSize,
    pageNumber
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashInInstead/getList',
        iid,
        userId,
        personId,
        groupNo,
        status,
        adjuestStatus,
        queryKey,
        pageSize,
        pageNumber,
        language:'CN'
      }
    })
  }
  saveCashInInstead({
    iid,
    userId,
    id,
    groupNo,
    receiveDate,
    project,
    totalPrice,
    type,
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashInInstead/save',
        iid,
        userId,
        id,
        groupNo,
        receiveDate,
        project,
        totalPrice,
        type,
        language:'CN'
      }
    })
  }
  delCashInInstead({
    iid,
    userId,
    id,
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashInInstead/delete',
        iid,
        userId,
        id,
        language:'CN'
      }
    })
  }
  getCashInInsteadDetail({
    iid,
    userId,
    id,
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/cashInInstead/get',
        iid,
        userId,
        id,
        language:'CN'
      }
    })
  }


  getCustomerInset({
    iid,
    userId,
    personId,
    groupNo,
    status,
    adjuestStatus,
    queryKey,
    pageSize,
    pageNumber
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/listBySales',
        iid,
        userId,
        personId,
        groupNo,
        status,
        adjuestStatus,
        queryKey,
        pageSize,
        pageNumber,
        language:'CN'
      }
    })
  }
  saveCustomerInset({
    iid,
    userId,
    id,
    infos,
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/input',
        iid,
        userId,
        id,
        infos,
        language:'CN'
      }
    })
  }
  delCustomerInset({
    iid,
    userId,
    status,
    id,
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/update',
        iid,
        userId,
        status,
        id,
        language:'CN'
      }
    })
  }
  getCustomerInsetDetail({
    iid,
    userId,
    id,
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/order/get',
        iid,
        userId,
        id,
        language:'CN'
      }
    })
  }



  //
  getListByPerson({
    iid,
    userId,
    status,
    groupType,
    queryKey,
    pageSize,
    pageNumber
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/group/groupInfo/getListByPerson',
        iid,
        userId,
        status,
        groupType,
        queryKey,
        pageSize,
        pageNumber
      }
    })
  }
  //
  getActivityLlist({
    iid,
    userId,
    status,
    groupType,
    queryKey,
    pageSize,
    pageNumber,
    pageNo
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/activity/list',
        iid,
        userId,
        status,
        groupType,
        queryKey,
        pageSize,
        pageNumber,
        pageNo
      }
    })
  }
  //
  getGroupLlist({
    iid,
    unionId,
    queryKey,
    pageSize,
    pageNumber
  } = {}) {
    return CommonService.getjsonp({
      body: {
        domain: 'reception.finger.inner',
        uri: '/v1/reception/groupClub/list',
        iid,
        unionId,
        queryKey,
        pageSize,
        pageNumber
      }
    })
  }

}

export default new appService()